<template>
  <store-recherche-provider
    v-if="mountedLoadingEnd"
    name="retardPaiementClient"
    :copy="retardPaiement"
    :copyChanges="changesListeRetardsStore"
    :isTemporary="true">
    <Liste-des-retards :isFromClient="true"/>
  </store-recherche-provider>
</template>

<script>
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import retardPaiement, { initialState as initialStateClient } from '@/store/modules/retardPaiement';
import * as allTypes from '@/store/mutation-type';
import ListeDesRetards from '@/components/relances/l_listeDesRetards';

export default {
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      retardPaiement,
      mountedLoadingEnd: false,
    };
  },
  components: {
    ListeDesRetards,
    storeRechercheProvider,
  },
  computed: {
    changesListeRetardsStore() {
      const initial = initialStateClient(this.tiersInformation);
      return {
        state: initial,
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = initial;
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
    this.mountedLoadingEnd = true;
  },
};
</script>
